<template>
  <div>
    <popup-add-product
      v-if="isProductType"
      ref="popupAddProduct"
      @productSelected="addProduct"
      :existingProducts="field.products"
    />
    <b-sidebar
      id="sidebar-right"
      z-index="51001"
      title="Edit field"
      right
      shadow
      :visible="active"
      backdrop
      no-header
      sidebar-class="sidebar-lg"
      header-class="header-dark"
      bg-variant="white"
      width="420px"
      @change="val => $emit('update:active', val)"
    >
      <!-- @hidden="clearForm" -->
      <!--<template #footer="{ hide }">
      <div class="d-flex header-dark text-light align-items-center px-3 py-2">
        <strong class="mr-auto">Footer</strong>
        <b-button size="sm" @click="hide">Close</b-button>
      </div>
    </template>-->

      <template #default="{ hide }" v-if="field">
        <!-- Header -->
        <div
          class="
            header-dark
            d-flex
            justify-content-between
            align-items-center
            content-sidebar-header
            px-4
            py-3
          "
        >
          <!--  <b-button size="sm" variant="outline-success rounded-lg">
          {{ "Completed" }}
        </b-button> -->
          <vs-dropdown class="cursor-pointer flex" vs-custom-content>
            <feather-icon
              :icon="getFieldIcon(field)"
              class="p-2 inline-flex rounded-lg bg-white border border-warning shadow-sm"
              svgClasses="h-5 w-5"
            />

            <vs-dropdown-menu style="z-index: 200001">
              <vs-dropdown-item
                :disabled="true"
                @click.stop="changeType(iconKey)"
                class="px-0 py-2"
                v-for="(availableField, index) in availableFields"
                :key="index"
              >
                <feather-icon
                  :icon="getFieldIcon(availableField)"
                  class="p-2 inline-flex rounded-lg bg-white border border-light-grey shadow-sm"
                  :class="{
                    'border-warning text-warning stroke-warning':
                      availableField.technicalType === field.technicalType,
                  }"
                  svgClasses="h-5 w-5"
                />
                <span class="ml-3">{{ getFieldName(availableField) }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <!--   <h5 v-else class="mb-0">Add Task</h5> -->
          <div>
            <feather-icon
              icon="TrashIcon"
              class="cursor-pointer mr-2"
              svgClasses="h-5 w-5 stroke-2"
              @click="
                $emit('delete:field', field);
                hide();
              "
            />
            <!--<feather-icon
            class="ml-3 cursor-pointer"
            icon="InfoIcon"
            svgClasses="h-5 w-5 stroke-2"
            
          />-->
            <feather-icon
              class="ml-3 cursor-pointer"
              icon="XIcon"
              svgClasses="h-5 w-5 stroke-2"
              @click="hide"
            />
          </div>
        </div>

        <div class="px-4">
          <!-- Form start -->
          <div>
            <form>
              <div class="vx-row">
                <div class="vx-col w-full">
                  <vs-row>
                    <vs-col vs-w="6">
                      <label class="mt-4 form-label">Field type</label>
                      <p>{{ getFieldName(field) }}</p>
                    </vs-col>
                    <vs-col vs-w="6">
                      <label class="mt-4 form-label">Input type</label>
                      <p>{{ field.type }}</p>
                    </vs-col>
                  </vs-row>
                  <label class="form-label">Label</label>
                  <vs-input v-model="field.label" class="w-full mb-4" placeholder="Label" />
                  <label class="form-label">Help text <small>(Optional)</small></label>
                  <vs-textarea rows="5" v-model="field.helpText" placeholder="Help text" />

                  <div v-if="hasRequiredField">
                    <label class="form-label">Required to fill this field?</label>
                    <div>
                      <vs-switch v-model="field.isRequired" class="rounded-full"> Switch </vs-switch>
                    </div>
                  </div>

                  <!-- Field type specific options -->
                  <!-- Dropdown -->
                  <div v-if="field.type === 'Dropdown'" class="mt-4">
                    <label class="form-label">Selectable options in the dropdown</label>
                    <ul class="list-group">
                      <li
                        class="list-group-item flex justify-between"
                        v-for="item in field.availableOptions"
                        :key="item"
                      >
                        <div>{{ item }}</div>
                        <feather-icon
                          @click="removeDropdownOption(item)"
                          icon="TrashIcon"
                          class="cursor-pointer mr-2"
                          svgClasses="h-5 w-5 stroke-2"
                        />
                      </li>
                    </ul>
                    <div class="flex justify-center mt-2">
                      <vs-input class="w-full" v-model="addDropdownInput"></vs-input>

                      <vs-button class="ml-2 py-2 px-3 rounded" @click="addDropdown">Add</vs-button>
                    </div>
                  </div>

                  <!-- Product -->
                  <div v-if="isProductType" class="mt-4">
                    <label class="form-label">Products in the list</label>
                    <ul class="list-group">
                      <li
                        class="list-group-item flex justify-between"
                        v-for="item in field.products"
                        :key="item.id"
                      >
                        <div class="flex items-center">
                          <img
                            v-if="item.imageUrl"
                            :src="item.imageUrl"
                            style="max-width: 48px"
                            class="rounded"
                          />
                          <div class="ml-2">
                            <div>
                              {{ item.name }}
                            </div>

                            <div>
                              <span>{{ item.price }}</span>
                              <span v-if="item.beforePrice != 0">
                                <span class="text-muted"> ({{ item.beforePrice }})</span>
                              </span>
                            </div>
                          </div>
                        </div>
                        <feather-icon
                          @click="removeProduct(item)"
                          icon="TrashIcon"
                          class="cursor-pointer mr-2"
                          svgClasses="h-5 w-5 stroke-2"
                        />
                      </li>
                    </ul>
                    <div class="flex justify-center mt-2">
                      <vs-button class="ml-2 py-2 px-3 rounded" @click="$refs.popupAddProduct.show()"
                        >Add</vs-button
                      >
                    </div>
                  </div>

                  <vs-row class="flex flex-wrap items-center mt-5">
                    <vs-button
                      class="mr-4 rounded-lg"
                      color="warning"
                      @click="
                        $emit('update:field');
                        hide();
                      "
                      >Save</vs-button
                    >
                    <vs-button class="rounded" color="primary" @click="hide">Cancel</vs-button>
                  </vs-row>
                  <!-- end  -->
                </div>
              </div>
            </form>
          </div>
          <!-- Form end -->
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PopupAddProduct from "./Components/PopupAddProduct.vue";
export default {
  components: {
    PopupAddProduct,
  },
  data() {
    return {
      selected: null,

      addDropdownInput: "",
    };
  },
  props: {
    field: {
      type: Object,
      default: () => ({}),
    },
    active: {
      type: Boolean,
      default: () => false,
    },
  },
  emits: ["update:active", "update:field", "delete:field"],
  computed: {
    ...mapGetters({
      availableFields: "bookingForms/availableFields",
      getFieldIcon: "bookingForms/getFieldIcon",
      getFieldName: "bookingForms/getFieldName",
    }),

    isProductType() {
      if (this.field == null) return false;
      return this.field.type === "Products" || this.field.type === "ProductsSingle";
    },

    hasRequiredField() {
      switch (this.field.type) {
        case "Number":
          return false;
        case "Products":
          return false;
        case "ProductsSingle":
          return false;
        default:
          return true;
      }
    },
  },
  methods: {
    // Dropdown specific
    addDropdown() {
      if (!this.addDropdownInput) return;
      this.field.availableOptions.push(this.addDropdownInput);
      this.addDropdownInput = "";
    },
    removeDropdownOption(item) {
      this.field.availableOptions = this.field.availableOptions.filter(i => i !== item);
    },

    addProduct(product) {
      console.log("addProduct", product);
      this.field.products.push(product);
    },
    removeProduct(product) {
      this.field.products = this.field.products.filter(e => e.id !== product.id);
    },

    changeType(type) {
      this.field.type = type;
    },
  },
  async mounted() {},
};
</script>


<style scoped lang="css" src="bootstrap/dist/css/bootstrap.min.css"></style>

<style scoped>
@import "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-vue/2.22.0/bootstrap-vue.min.css";

.header-dark {
  background-color: #f6f6f6;
}
.form-label {
  color: #5e5873;
  font-size: 0.857rem;
}
</style>
